import { useBranding } from "@/contexts/BrandingContext";
import LandingPage from "@/pages/marketing/LandingPage";
import MarketingSEO from "@/components/marketing/MarketingSEO";
import ClassicTemplate from "@/pages/public/Home";
import TribunTemplate from "@/pages/public/templates/TribunTemplate";
import ModernTemplate from "@/pages/public/templates/ModernTemplate";
import MinimalistTemplate from "@/pages/public/templates/MinimalistTemplate";
import HibritTemplate from "@/pages/public/templates/HibritTemplate";
import { SiteDisabled } from "@/components/public/SiteDisabled";

/**
 * HomeRouter — top-level router for `/`.
 * - If the request comes from the platform host (draifutbol.com or preview URL with
 *   no club override), render the DR AI FUTBOL marketing landing page.
 * - Otherwise, pick the club's homepage template based on `theme_template`.
 */
const TEMPLATES = {
    classic: ClassicTemplate,
    tribun: TribunTemplate,
    modern: ModernTemplate,
    minimalist: MinimalistTemplate,
    hibrit: HibritTemplate,
};

export default function HomeRouter() {
    const { branding, loaded } = useBranding();
    if (!loaded) {
        return <div className="min-h-screen bg-dr-black" />;
    }
    if (branding?.is_platform) {
        return (
            <>
                <MarketingSEO
                    description="Türk futbol kulüpleri için yapay zeka destekli dijital yönetim platformu. Kurumsal web sitesi + 360° yönetim paneli + AI sosyal medya — tek pakette."
                    path="/"
                />
                <LandingPage />
            </>
        );
    }
    const key = branding?.theme_template || "classic";
    const Template = TEMPLATES[key] || ClassicTemplate;
    if (branding?.site_enabled === false) return <SiteDisabled />;
    return <Template />;
}
